import React, { Component } from 'react';
import ReportsLayout from '../../templates/reports';
import Summary from '../../elements/reports/summary';
import Loading from './../../elements/loading';

class ReportsSummary extends Component{
	render (){
		let { reports, modalities } = this.props;
		let { summary } = reports;
		return (
			summary.isFetching || modalities.isFetching ? <Loading message="Cargando Resumen..."/>:<Summary {...this.props}/>
		)
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;

		this.props.fetchModalities();
		this.props.reportsSummary(modality, state, municipality);

	}

	componentWillReceiveProps(newprops) {
		let { modality, state, municipality } = newprops.match.params;

		if(newprops.match.params !== this.props.match.params) {
			this.props.reportsSummary(modality, state, municipality);
		}
	}
}

export default ReportsLayout(ReportsSummary, {subnav: 5});


// WEBPACK FOOTER //
// ./src/layouts/reports/summary.jsx